import { Component, Event, EventEmitter, JSX, Prop, h } from '@stencil/core'

import { QuestionGroupChange } from './air-question-group.types'

@Component({
  tag: 'air-question-group',
  styleUrl: 'air-question-group.scss',
  shadow: true,
})
export class AirQuestionGroup {
  /** Question object */
  @Prop() questionIdToChange!: string

  /** Count of visible inner items */
  @Prop() visibleCount = 1

  /** Maximum limit */
  @Prop() max!: number

  /** Use secondary buttons */
  @Prop() isSecondary = false

  /** Triggers when increasing or decreasing the current value */
  @Event({ eventName: 'air-group-control-change' }) change?: EventEmitter<QuestionGroupChange>

  private increase = (): void => {
    this.change?.emit({ visibleCount: this.visibleCount + 1, questionId: this.questionIdToChange })
  }

  private decrease = (): void => {
    this.change?.emit({ visibleCount: this.visibleCount - 1, questionId: this.questionIdToChange })
  }

  private addText = (): string =>
    /Location\d+Address/.test(this.questionIdToChange) ? 'Add another location' : 'Add'

  private removeText = (): string =>
    /Location\d+Address/.test(this.questionIdToChange) ? 'Remove this location' : 'Remove'

  render(): JSX.Element {
    const increasingDisabled = this.visibleCount === this.max
    const questionGroupControlsClasses = {
      'question-group-controls': true,
      [`secondary`]: this.isSecondary,
    }
    return (
      <div class="question-group">
        <slot></slot>
        <div class={questionGroupControlsClasses}>
          {this.visibleCount > 1 &&
            (this.isSecondary ? (
              <a class="air-link-secondary" onClick={this.decrease}>
                {this.removeText()}
              </a>
            ) : (
              <air-button
                class="button remove-question-button"
                variant="tertiary"
                onClick={this.decrease}
              >
                {this.removeText()}
              </air-button>
            ))}
          {this.visibleCount > 1 && !this.isSecondary && <air-divider></air-divider>}
          {this.isSecondary ? (
            !increasingDisabled && (
              <a
                class="air-link air-link-navigation"
                onClick={increasingDisabled ? void 0 : this.increase}
              >
                {this.addText()}
              </a>
            )
          ) : (
            <air-button
              disabled={increasingDisabled}
              class="button add-question-button"
              onClick={increasingDisabled ? void 0 : this.increase}
              variant="secondary"
            >
              {this.addText()}
            </air-button>
          )}
        </div>
      </div>
    )
  }
}
